import { Dispatch } from 'redux'

import { NodeData } from 'types/transformation/types/nodes'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'
import * as Api from 'redux/api/DataPlatform/tables/v4'
import * as actions from './actions'

import { SnackbarMessage } from 'types/GlobalSnackbar'

function tryGetOneSIMTable(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getOneSIMTable())

    Api.getOne(id)
      .then((response) => {
        dispatch(actions.getOneSIMTableSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getOneSIMTableFailed())
      })
  }
}

function tryPutSIMTable(
  id: string,
  nodes: NodeData[],
  cb: (err?: string) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putSIMTable())

    Api.put(id, nodes)
      .then((response) => {
        dispatch(actions.putSIMTableSuccess(response.data.data))

        cb()
      })
      .catch(() => {
        dispatch(actions.putSIMTableFailed())
        cb('error')
      })
  }
}

/**
 * Promote this one table's modelling to production. The board itself keeps
 * showing the test environment, so there is nothing to refetch — the callback
 * reports the outcome the same way tryPutSIMTable does.
 */
function tryTransferSIMTableToProduction(
  id: string,
  cb: (err?: string) => void
) {
  return (dispatch: Dispatch) => {
    Api.transferToProduction(id)
      .then(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        cb()
      })
      .catch(() => {
        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        cb('error')
      })
  }
}

export const useSIMTableActions = () => {
  return {
    tryGetOneSIMTable: useThunkActions(tryGetOneSIMTable),
    tryPutSIMTable: useThunkActions(tryPutSIMTable),
    tryTransferSIMTableToProduction: useThunkActions(
      tryTransferSIMTableToProduction
    ),
    tryGetVersions: (id: string) =>
      Api.getVersions(id).then((r) => r.data.data),
    tryGetVersion: (id: string, timestamp: string) =>
      Api.getVersion(id, timestamp).then((r) => r.data.data)
  }
}
